export default __webpack_public_path__ + "static/media/image-best-gear.37743784.jpg";